import React, { useState } from "react";
import { Link } from "react-router-dom";
import BackArrow from "../assets/images/back-arrow.svg";
import { Camera } from "lucide-react"; // You can replace with any icon
import InfoIcon from "../assets/images/info.svg";
import TakePhoto from "../assets/images/take-photo.svg";

const AssistantInstructions = () => {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="mx-auto tab-screen">
      <div className="flex mb-5 px-6 relative z-50">
        <Link
          to={-1}
          className="w-9 h-9 bg-[#2D2D2D] rounded-full flex justify-center items-center"
        >
          <img src={BackArrow} alt="Back" />
        </Link>
        <div className="ml-4 -mt-1">
          <h1 className="text-lg font-semibold">
            Dental <span className="text-secondary">Scan</span>
          </h1>
          <p className="text-xs text-white/85">
            Comprehensive oral health analysis
          </p>
        </div>
      </div>
      {/* Background Blur */}
      <div className="circle-blur w-[75%] h-64 mx-auto mt-10 blur-[90px] absolute left-0 right-0 top-10"></div>
      <div className="w-full px-6">
        <div className="bg-[#1D1D1D]/70 rounded-[20px] px-5 pt-5 pb-6 mb-7 relative z-50">
          <div className="flex items-center mb-2">
            <span className="bg-blue-100 p-2 rounded-full mr-3">
              <img src={TakePhoto} alt="" />
            </span>
            <div className="flex flex-col">
              <h3 className="text-base font-semibold text-white mb-1 flex items-center">
                Assisted Photo Mode
              </h3>
              <p className="text-xs text-white/85 leading-3">
                Instructions for the person helping
              </p>
            </div>
          </div>
          <div className="flex mt-6">
            <img src={InfoIcon} className="mr-2 w-3 h-3" alt="" />
            <p className="text-xxs text-white/85 leading-4">
              <span className="font-semibold">For the Assistant:</span> You’ll
              be helping to take clear dental photos. Follow the step-by-step
              instructions below.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white px-6 mx-6 pt-6 pb-24">
        <h4 className="text-base font-semibold mb-3 text-primary">
          General Guidelines:
        </h4>
        <ul className="space-y-2 text-sm text-gray-700">
          {[
            "Position yourself to have a clear view of the patient’s mouth area",
            "Ensure good lighting – preferably natural light or bright room lighting",
            "Hold the device steady and at the correct angle for each shot",
            "Help guide the patient through each pose as described",
            "Take multiple shots if needed to get the clearest image",
            "Communicate clearly and be patient throughout the process",
          ].map((text, index) => (
            <li
              key={index}
              className="bg-blue-50 border border-blue-200 p-2 rounded-xl flex items-start gap-2"
            >
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-blue-500 text-white text-xs">
                {index + 1}
              </span>
              <span className="text-xs w-10/12 text-primary">{text}</span>
            </li>
          ))}
        </ul>

        <div className="mt-5 p-3 rounded-md flex items-start gap-2">
          <input
            type="checkbox"
            id="acknowledge"
            checked={agreed}
            onChange={() => setAgreed(!agreed)}
            className="accent-blue-200 border border-blue-800 mt-1"
          />
          <label htmlFor="acknowledge" className="text-xs text-primary">
            I understand the instructions and am ready to assist with photo
            capture
          </label>
        </div>

        <div className="mt-4 flex w-full">
          <Link
            className={`flex w-6/12 mx-auto h-12 items-center justify-center rounded-full gap-2 text-sm px-3 py-1 ${
              agreed
                ? "bg-primary hover:bg-secondary text-white"
                : "bg-primary/40 cursor-not-allowed text-white/70"
            }`}
            disabled={!agreed}
            to="/dental-analyzer"
          >
            <Camera size={16} />
            Start Taking Photos
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AssistantInstructions;
